import React, { useMemo } from "react";
import HeroSection from "./Components/HeroSection";
import OurCourses from "./Components/OurCourses";
// import AboutUs from "./Components/AboutUs";
import DeliveryMethods from "./Components/DeliveryMethods";
import Accordion from "./Components/Accordion";
import Contact from "./Components/Contact";
// import VideoThumbnail from "./Components/VideoThumbnail";
import ReviewSlider from "./Components/ReviewSlider";
import useSWR from "swr";
import {
  staticHomeUrls,
  NewsApiUrls,
  BlogApiUrls,
} from "../../Api/Auth/ApiUrls";
import News from "./Components/News";
import Blogs from "./Components/Blogs";
import { noAuthfetcher } from "../../Api/swrConfig";
import HomeVideos from "./Components/HomeVideos";
import { motion } from "framer-motion";

const DEFAULT_ACCORDION_DATA = [
  {
    title: "Who We Are?",
    content:
      "Driven Innovators: A team passionate about transforming PE exam preparation. Expert Contributors: Engineers and educators dedicated to quality and clarity. Your Support System: Committed to helping you succeed on your path to licensure.",
  },
  {
    title: "What We Provide?",
    content:
      "High-Quality Practice Problems: Carefully crafted questions that mirror real exam scenarios. Clear, Concise Resources: Streamlined content designed for effective learning. Comprehensive Coverage: Extensive material that spans all relevant NCEES topics.",
  },
  {
    title: "How We Do That?",
    content:
      "Rigorous Standards: Each problem meets the latest NCEES specifications for accuracy and relevance. User-Centric Design: An intuitive platform that enhances your study experience. Continuous Improvement: Regular updates based on feedback and exam trends to keep our content current.",
  },
  {
    title: "Why You Can Trust Us?",
    content:
      "Proven Expertise: Our team includes seasoned professionals in engineering and education. Transparent Practices: We maintain open communication about our methods and processes. Commitment to Excellence: We regularly update materials based on the latest trends and feedback.",
  },
];

const Home = () => {
  const { data } = useSWR(staticHomeUrls.home, noAuthfetcher);
  const { data: newsData } = useSWR(NewsApiUrls.list("limit=2"), noAuthfetcher);
  const { data: blogsData } = useSWR(
    BlogApiUrls.list("limit=2"),
    noAuthfetcher
  );
  const parsedContent = useMemo(() => {
    try {
      return data?.data?.content ? JSON.parse(data.data.content) : {};
    } catch (error) {
      console.warn("Failed to parse static home content", error);
      return {};
    }
  }, [data]);

  const accordionData = useMemo(() => {
    if (
      Array.isArray(parsedContent?.accordions) &&
      parsedContent.accordions.length
    ) {
      const normalized = parsedContent.accordions
        .map((item) => ({
          title: item?.title || "",
          content: item?.content || "",
        }))
        .filter((item) => item.title || item.content);

      if (normalized.length) {
        return normalized;
      }
    }
    return DEFAULT_ACCORDION_DATA;
  }, [parsedContent]);

  const contactData = useMemo(() => {
    const title = parsedContent?.contactTitle?.trim();
    const description = parsedContent?.contactDescription;
    const buttonText = parsedContent?.contactButtonText?.trim();

    return {
      ...(title ? { title } : {}),
      ...(description ? { description } : {}),
      ...(buttonText ? { buttonText } : {}),
    };
  }, [parsedContent]);

  const showReviews =
    typeof parsedContent?.showReviews === "boolean"
      ? parsedContent.showReviews
      : true;
  return (
    <div>
      <motion.div
        initial={{ opacity: 1, y: -40 }} // Start above the view
        whileInView={{ opacity: 1, y: 0 }} // End at normal position
        transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
      >
        <HeroSection data={data} />
      </motion.div>
      <motion.div
        initial={{ opacity: 1, y: -40 }} // Start above the view
        whileInView={{ opacity: 1, y: 0 }} // End at normal position
        transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
      >
        <OurCourses />
      </motion.div>
      <motion.div
        initial={{ opacity: 1, y: -40 }} // Start above the view
        whileInView={{ opacity: 1, y: 0 }} // End at normal position
        transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
      >
        <HomeVideos data={data} />
      </motion.div>
      <motion.div
        initial={{ opacity: 1, y: -40 }} // Start above the view
        whileInView={{ opacity: 1, y: 0 }} // End at normal position
        transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
      >
        <DeliveryMethods data={data} />
      </motion.div>
      <motion.div
        initial={{ opacity: 1, y: -40 }} // Start above the view
        whileInView={{ opacity: 1, y: 0 }} // End at normal position
        transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
      >
        <Accordion accordionData={accordionData} html />
      </motion.div>
      <motion.div
        initial={{ opacity: 1, y: -40 }} // Start above the view
        whileInView={{ opacity: 1, y: 0 }} // End at normal position
        transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
      >
        <News items={newsData?.data || []} />
      </motion.div>
      <motion.div
        initial={{ opacity: 1, y: -40 }} // Start above the view
        whileInView={{ opacity: 1, y: 0 }} // End at normal position
        transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
      >
        <Blogs items={blogsData?.data || []} />
      </motion.div>
      {showReviews && (
        <motion.div
          initial={{ opacity: 1, y: -40 }} // Start above the view
          whileInView={{ opacity: 1, y: 0 }} // End at normal position
          transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
        >
          <ReviewSlider data={parsedContent?.reviews} />
        </motion.div>
      )}
      <motion.div
        initial={{ opacity: 1, y: -40 }} // Start above the view
        whileInView={{ opacity: 1, y: 0 }} // End at normal position
        transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
      >
        <Contact data={contactData} />
      </motion.div>
      {/* <AboutUs /> */}
    </div>
  );
};

export default Home;
